// utils/recommendationUtils.ts
export function shouldShowRecommendation(
  currentUrl: string,
  recommendationsConfig: any[],
  recommendationType: 'trendingItems' | 'trendingFacetsValue',
  isEnableTrending?: boolean,
  isPLP?: boolean,
): boolean {
  if (!isEnableTrending) return false; // Global switch is off
  if (!isPLP) return true;

  if (!recommendationsConfig || !currentUrl) return false;

  // Find the config that matches the current URL
  const matchedConfig = recommendationsConfig.find((configItem) => configItem.url === currentUrl);

  if (!matchedConfig) return false;

  // Check if the specific recommendation type is enabled in this page config
  return matchedConfig[recommendationType] === true;
}
